<template>
  <MainLayout fluid>
      <LocationGroupsTable />
  </MainLayout>
</template>

<script>
import MainLayout from '@/layouts/Main'
import ItemTableTemplate from '@/components/ItemTableTemplate'
import ItemTable from '@/components/ItemTable'
import LocationGroup from '@/resources/LocationGroup'

const LocationGroupsTable = {
  ...ItemTableTemplate,
  mixins: [ItemTable(LocationGroup)]
}

export default {
  components: { MainLayout, LocationGroupsTable },
  metaInfo() {
    return {
      title: this.$t('location_groups.title'),
    }
  },
};
</script>